import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { impactData } from "../data";
import { staggerContainer, counterVariant } from "../variants";

const useCounter = (target, duration = 2000, isActive = false) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isActive) return;
    let start = 0;
    const step = target / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [target, duration, isActive]);

  return count;
};

const StatItem = ({ item, isActive }) => {
  const count = useCounter(item.value, 2200, isActive);

  return (
    <motion.div
      variants={counterVariant}
      className="flex flex-col items-center text-center px-8 py-8 lg:py-10 group"
    >
      <div className="font-display text-5xl lg:text-6xl font-bold text-white mb-2 tabular-nums leading-none">
        {count}
        <span className="text-secondary text-3xl lg:text-4xl">{item.suffix}</span>
      </div>
      <div className="text-white/70 text-sm font-body tracking-wide uppercase font-medium">
        {item.label}
      </div>
      <div className="w-8 h-0.5 bg-secondary/50 rounded-full mt-3 group-hover:bg-secondary transition-colors duration-300" />
    </motion.div>
  );
};

const ImpactBar = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section ref={ref} className="bg-primary relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute -top-20 -left-20 w-80 h-80 rounded-full bg-white" />
        <div className="absolute -bottom-20 -right-20 w-80 h-80 rounded-full bg-secondary" />
      </div>

      <div className="relative container mx-auto">
        <motion.div
          variants={staggerContainer(0.15, 0.1)}
          initial="hidden"
          animate={isInView ? "show" : "hidden"}
          className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-white/10"
        >
          {impactData.map((item, i) => (
            <StatItem key={i} item={item} isActive={isInView} />
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ImpactBar;
